export default "__VITE_ASSET__eT8n_lc$__"